<template>
  <div class="payment-result-redirect"></div>
</template>

<script>
export default {
  name: 'PaymentResult',
  created() {
    this.$router.replace('/approvel-pass-result')
  },
}
</script>

<style scoped>
.payment-result-redirect {
  min-height: 100vh;
  background: #f8f8f8;
}
</style>
